module.exports = __webpack_public_path__ + "img/enquiry.ea575684.svg";